(() => {
  'use strict';
  const init = () => {
    const page = document.querySelector('[data-dm-page]');
    const contextNode = page?.querySelector('[data-dm-localization-context]');
    if (!page || !contextNode || window.DM_MARKET) return;
    const server = JSON.parse(contextNode.textContent);
    const config = window.DM_MARKET_CONFIG;
    if (!config) return;
    const markets = config.markets;
    const currentUrl = new URL(location.href);
    const requested = (currentUrl.searchParams.get('country') || '').toUpperCase();
    const country = markets[server.country] ? server.country : 'PT';
    const market = markets[country];
    if (country === 'PL') window.DM_DICTIONARIES.pl = JSON.parse(document.querySelector('[data-audio-poland-dictionary="mania"]').textContent);
    const dictionary = window.DM_DICTIONARIES?.[market.language] || {};
    const normalize = text => text.replace(/\s+/g, ' ').trim();
    const t = (source, values = {}) => {
      let result = dictionary[normalize(source)] || source;
      Object.entries(values).forEach(([key, value]) => { result = result.replaceAll('{' + key + '}', String(value)); });
      return result;
    };
    const originals = new WeakMap();
    const excluded = element => element?.closest?.('script,style,[data-dm-policy-original],[data-dm-no-translate]');
    const translateText = node => {
      if (excluded(node.parentElement)) return;
      const current = node.nodeValue, key = normalize(current);
      if (!key) return;
      let source = originals.get(node);
      if (!source || normalize(t(source)) !== key) source = current;
      originals.set(node, source);
      const translated = t(normalize(source));
      if (translated !== normalize(source) && normalize(current) !== normalize(translated)) node.nodeValue = source.replace(/\S[\s\S]*\S|\S/, translated);
    };
    const translateElement = element => {
      if (excluded(element)) return;
      if (element.dataset.dmOnlyCountry) element.hidden = element.dataset.dmOnlyCountry !== country;
      for (const name of ['aria-label', 'alt', 'title', 'placeholder', 'data-title', 'data-category']) {
        const value = element.getAttribute(name);
        if (value && dictionary[normalize(value)]) {
          const translated = t(value);
          if (translated !== value) element.setAttribute(name, translated);
        }
      }
    };
    const translateTree = root => {
      if (!root) return;
      if (root.nodeType === Node.TEXT_NODE) { translateText(root); return; }
      if (![Node.ELEMENT_NODE, Node.DOCUMENT_FRAGMENT_NODE].includes(root.nodeType) || excluded(root)) return;
      if (root.nodeType === Node.ELEMENT_NODE) translateElement(root);
      root.querySelectorAll('[aria-label],[alt],[title],[placeholder],[data-title],[data-category],[data-dm-only-country]').forEach(translateElement);
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) translateText(walker.currentNode);
    };
    const variants = JSON.parse(page.querySelector('[data-dm-variants]')?.textContent || '[]');
    const state = window.DM_MARKET = { country, market, variants, verified: false, pending: true, switching: false, t, translateTree, server };
    window.DM_I18N = { t, translateTree };
    document.documentElement.lang = market.language;
    page.dataset.dmCountry = country; page.dataset.dmLanguage = market.language; page.dataset.dmCurrency = market.currency;
    page.querySelectorAll('[data-dm-only-country]').forEach(element => { element.hidden = element.dataset.dmOnlyCountry !== country; });
    translateTree(page); translateTree(document.querySelector('.dm-skip'));
    page.querySelectorAll('template[data-dm-footer-content]').forEach(template => translateTree(template.content));
    const observer = new MutationObserver(records => {
      for (const record of records) {
        if (record.type === 'characterData') translateText(record.target);
        else if (record.type === 'attributes') translateElement(record.target);
        else record.addedNodes.forEach(translateTree);
      }
    });
    observer.observe(page, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'alt', 'title'] });
    const dialog = page.querySelector('[data-dm-market-dialog]');
    const desktopCountryControls = window.matchMedia('(min-width:1068px) and (hover:hover) and (pointer:fine)');
    const form = page.querySelector('#dm-localization-form');
    const message = page.querySelector('[data-dm-market-message]');
    let opener, previousOverflow = null, switchTimer;
    const languages = { 'pt-PT': 'Português', de: 'Deutsch', hr: 'Hrvatski', ro: 'Română', hu: 'Magyar', cs: 'Čeština', pl: 'Polski' };
    const options = page.querySelector('[data-dm-market-options]');
    Object.entries(markets).forEach(([code, item]) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'dm-market-option'; button.dataset.dmChangeCountry = code;
      button.setAttribute('aria-pressed', String(code === country));
      const main = document.createElement('span'); main.textContent = item.countryName;
      const detail = document.createElement('small'); detail.textContent = languages[item.language] + ' · ' + item.currency;
      button.append(main, detail); options.append(button);
    });
    page.querySelectorAll('[data-dm-market-name]').forEach(element => { element.textContent = market.countryName + ' · ' + market.currency; });
    page.querySelectorAll('[data-dm-market-code]').forEach(element => { element.textContent = country + ' · ' + market.currency; });
    page.querySelectorAll('[data-dm-market-open]').forEach(trigger => trigger.addEventListener('click', () => {
      if (!desktopCountryControls.matches) return;
      opener = trigger; previousOverflow = document.documentElement.style.overflow;
      dialog.showModal(); document.documentElement.style.overflow = 'hidden'; trigger.setAttribute('aria-expanded', 'true');
    }));
    const restoreDialog = () => {
      if (previousOverflow === null) return;
      document.documentElement.style.overflow = previousOverflow;
      previousOverflow = null;
      page.querySelectorAll('[data-dm-market-open]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
      if (desktopCountryControls.matches && opener?.getClientRects().length) opener.focus({ preventScroll: true });
    };
    const closeDialog = () => { dialog.close(); restoreDialog(); };
    const closeNonDesktopDialog = () => { if (!desktopCountryControls.matches && dialog.open) closeDialog(); };
    desktopCountryControls.addEventListener('change', closeNonDesktopDialog);
    closeNonDesktopDialog();
    page.querySelector('[data-dm-market-close]').addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(); });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();
    });
    dialog.addEventListener('close', () => { if (!dialog.open) restoreDialog(); });
    const notify = () => window.dispatchEvent(new CustomEvent('dm:market-state', { detail: state }));
    const switchCountry = code => {
      const target = markets[code];
      if (!target || state.switching || state.checkoutPending) return;
      if (code === server.country && server.language === target.language) { closeDialog(); return; }
      state.switching = true; notify();
      const destination = new URL(location.href);
      destination.pathname = target.root + '/products/' + server.handle;
      destination.searchParams.set('country', code);
      destination.searchParams.set('dm_market_attempt', code);
      const selected = page.querySelector('[data-dm-variant-select]')?.value;
      if (selected && variants.some(variant => String(variant.id) === selected)) destination.searchParams.set('variant', selected);
      form.elements.country_code.value = code; form.elements.language_code.value = target.language;
      form.querySelectorAll('input[name="return_to"]').forEach(input => { input.value = destination.pathname + destination.search + destination.hash; });
      message.textContent = t('A mudar de país…'); message.hidden = false;
      options.querySelectorAll('button').forEach(button => { button.disabled = true; });
      switchTimer = setTimeout(() => {
        state.switching = false; notify();
        options.querySelectorAll('button').forEach(button => { button.disabled = false; });
        message.textContent = t('Não foi possível mudar de país. Tente novamente.');
      }, 12000);
      form.requestSubmit();
    };
    options.addEventListener('click', event => { const button = event.target.closest('[data-dm-change-country]'); if (button) switchCountry(button.dataset.dmChangeCountry); });
    window.addEventListener('pagehide', () => clearTimeout(switchTimer), { once: true });
    const attempted = currentUrl.searchParams.get('dm_market_attempt');
    const desired = markets[requested] ? requested : country;
    if ((desired !== server.country || server.language !== markets[desired].language) && attempted !== desired) {
      switchCountry(desired); return;
    }
    if (desired !== server.country || server.language !== markets[desired].language) {
      state.pending = false;
      message.textContent = t('Não foi possível mudar de país. Tente novamente.'); message.hidden = false;
      page.querySelector('[data-dm-market-status]').textContent = message.textContent;
      notify(); return;
    }
    if (attempted) { currentUrl.searchParams.delete('dm_market_attempt'); history.replaceState({}, '', currentUrl.pathname + currentUrl.search + currentUrl.hash); }
    const priceStatus = page.querySelector('[data-dm-market-status]');
    let verification;
    const verifyPrices = async () => {
      if (verification) return verification;
      verification = (async () => {
        state.pending = true; state.verified = false; priceStatus.textContent = t('A verificar os preços…'); notify();
        try {
          if (market.language !== 'pt-PT' && !window.DM_DICTIONARIES?.[market.language]) throw new Error('Language unavailable');
          const response = await fetch('/api/2026-10/graphql.json', {
            signal: AbortSignal.timeout(15000),
            method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ query: 'query ManiaMarketPrices($ids: [ID!]!, $country: CountryCode!, $language: LanguageCode!) @inContext(country: $country, language: $language) { nodes(ids: $ids) { ... on ProductVariant { id availableForSale price { amount currencyCode } compareAtPrice { amount currencyCode } product { id handle } } } localization { country { isoCode currency { isoCode } } language { isoCode } } }', variables: { ids: variants.map(variant => 'gid://shopify/ProductVariant/' + variant.id), country, language: market.apiLanguage } })
          });
          const result = await response.json(), nodes = result.data?.nodes;
          if (!response.ok || result.errors?.length || nodes?.length !== 12 || variants.length !== 12 || result.data.localization.country.isoCode !== country || result.data.localization.country.currency.isoCode !== market.currency || result.data.localization.language.isoCode !== market.apiLanguage) throw new Error('Market unavailable');
          const prices = variants.map(variant => {
            const node = nodes.find(item => item?.id === 'gid://shopify/ProductVariant/' + variant.id);
            const expectedPrice = variant.bundle ? market.kit : market.base, expectedCompare = variant.bundle ? market.kitCompare : market.baseCompare;
            if (!node || node.product.id !== 'gid://shopify/Product/' + server.productId || node.price.currencyCode !== market.currency || !(Number(node.price.amount) > 0) || (country === 'PL' ? node.compareAtPrice && node.compareAtPrice.currencyCode !== market.currency : node.compareAtPrice?.currencyCode !== market.currency || Number(node.price.amount) !== Number(expectedPrice) || Number(node.compareAtPrice.amount) !== Number(expectedCompare))) throw new Error('Price mismatch');
            return { variant, node };
          });
          const money = amount => new Intl.NumberFormat(market.locale, { style: 'currency', currency: market.currency, minimumFractionDigits: 0, maximumFractionDigits: 2 }).format(Number(amount));
          prices.forEach(({ variant, node }) => { variant.price = Math.round(Number(node.price.amount) * 100); variant.comparePrice = Math.round(Number(node.compareAtPrice?.amount || 0) * 100); variant.moneyText = money(node.price.amount); variant.compareText = country === 'PL' && !(Number(node.compareAtPrice?.amount) > 0) ? '' : money(node.compareAtPrice?.amount || 0); variant.available = node.availableForSale; });
          state.verified = true; priceStatus.textContent = '';
        } catch { priceStatus.textContent = t('Os preços para este país não puderam ser confirmados. Tente novamente.'); }
        finally { state.pending = false; verification = null; notify(); }
      })();
      return verification;
    };
    state.verifyPrices = verifyPrices;
    window.addEventListener('pageshow', event => {
      if (!event.persisted) return;
      clearTimeout(switchTimer); state.switching = false;
      options.querySelectorAll('button').forEach(button => { button.disabled = false; });
      message.hidden = true; closeDialog();
    });
    page.querySelector('[data-dm-market-retry]')?.addEventListener('click', verifyPrices);
    verifyPrices();
    page.dataset.dmLocalized = 'true';
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
